<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <VDialog v-model="dialogLoading" :max-width="700">
    <VCard class="pa-sm-10 pa-5">
      <VCardTitle class="text-center">Cargando información</VCardTitle>
      <VProgressLinear indeterminate color="primary"></VProgressLinear>
    </VCard>
  </VDialog>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content report-box  container-fluid">
      <!-- Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <breadcrumbthree :title="title" :text="text" :text1="text1" />
        </div>
      </div>
      
      <div>
        <h1>{{ $store.getters.currentAdminLanguage === 'en' ? 'Welcome' : 'Bienvenido' }}</h1>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Atributos de Nuestra Marca</span>
            <div class="col-auto" style="float:right">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#add_attribute"
                @click="clearValuesAttribute"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>

        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model="searched_attribute"
                    @input="localSearch(searched_attribute, dataTableAttributes, 'attributes')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableAttributes"
                  :data-source="dataTableFiltAttributes"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'title'">
                        <div>{{ record.title }}</div>
                    </template>
                    <template v-if="column.key === 'description'">
                        <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'photo'">
                        <div><img :src="record.photo" style="max-width:64px"/></div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_attribute"
                          @click="loadEditModalAttribute(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_attribute"
                          @click="loadDeleteModalAttribute(record)"
                          ><i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Nuestros Líderes</span>
            <div class="col-auto" style="float:right">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#add_leader"
                @click="clearValuesLeader"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model="searched_leader"
                    @input="localSearch(searched_leader, dataTableLeaders, 'leaders')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableLeaders"
                  :data-source="dataTableFiltLeaders"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'rotulo'">
                        <div>{{ record.rotulo }}</div>
                    </template>
                    <template v-if="column.key === 'photo'">
                        <div><img :src="record.photo" style="max-width:64px"/></div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_leader"
                          @click="loadEditModalLeader(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                        href="javascript:void(0);"
                        class="btn btn-sm btn-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_leader"
                        @click="loadDeleteModalLeader(record)"
                        >
                          <i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Fotos de la Empresa</span>
            <div class="col-auto" style="float:right">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#add_gallery"
                @click="clearValuesGallery"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model="searched_gallery"
                    @input="localSearch(searched_gallery, dataTableGallery, 'gallery')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableGallery"
                  :data-source="dataTableFiltGallery"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'description'">
                        <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'photo'">
                        <div>
                          <img :src="record.photo" style="max-width:64px"/>
                        </div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_gallery"
                          @click="loadEditModalGallery(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_gallery"
                          @click="loadDeleteModalGallery(record)"
                          ><i class="far fa-trash-alt"></i
                        ></a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- /Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <h3 class="page-title">
            <span>Yo elijo trabajar en Agrovision</span>
            <div class="col-auto" style="float:right">
              <a
                class="btn add-user"
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#add_testimony"
              >
                <i class="fas fa-plus"></i> Agregar Registro </a>
            </div>
          </h3>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrar
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  Registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    aria-controls="DataTables_Table_0"
                    v-model="searched_testimonial"
                    @input="localSearch(searched_testimonial, dataTableTestimonials, 'testimonial')"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columnsTableTestimonials"
                  :data-source="dataTableFiltTestimonials"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'title'">
                        <div>{{ record.title }}</div>
                    </template>
                    <template v-if="column.key === 'description'">
                        <div>{{ record.description }}</div>
                    </template>
                    <template v-if="column.key === 'photo'">
                        <div><img :src="record.photo" style="max-width:64px"/></div>
                    </template>
                    <template v-if="column.key === 's3_url'">
                        <div><img :src="record.s3_url" style="max-width:64px"/></div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_card"
                          @click="loadEditModalTestimonial(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete_card"
                          @click="loadDeleteModalTestimonial(record)"
                          ><i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-------------------------------------- Modales Atributos -------------------------------------->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_attribute">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addAttribute">
            <div class="form-group">
              <label>Descripción</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion"
              v-model="desc_attribute">
              </textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeAttribute"
              />
              <div class="img-preview">
                <img :src="img_preview_attribute"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->
  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_attribute">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editAttribute">
            <div class="form-group">
              <label>Descripcion</label>
              <input 
              class="form-control" 
              name="txt-rotulo" 
              v-model="desc_attribute"
              />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeAttribute"
              />
              <div class="img-preview">
                <!-- <button title="Quitar" class="btn btn-danger"><i class="fa fa-trash"></i></button> -->
                <img :src="img_preview_attribute"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->
  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_attribute" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-agv-dos continue-btn" data-bs-dismiss="modal" @click="deleteAttribute(record)"
                  >Eliminar</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->

  <!-------------------------------------- Modales Lideres -------------------------------------->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_leader">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addLeader">
            <div class="form-group">
              <label>Nombre</label>
              <input 
                class="form-control" 
                name="txt-nombre" 
                v-model="name_leader" 
              />
            </div>
            <div class="form-group">
              <label>Cargo</label>
              <input 
                class="form-control" 
                name="txt-cargo" 
                v-model="work_pos_leader" 
              />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeLeader"
              />
              <div class="img-preview">
                <img :src="img_preview_leader"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->

  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_leader">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editLeader">
            <div class="form-group">
              <label>Nombre</label>
              <input 
                class="form-control" 
                name="txt-nombre" 
                v-model="name_leader" 
              />
            </div>
            <div class="form-group">
              <label>Cargo</label>
              <input 
                class="form-control" 
                name="txt-cargo" 
                v-model="work_pos_leader" 
              />
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeLeader"
              />
              <div class="img-preview">
                <img :src="img_preview_leader"/>
              </div>
            </div>
            <div class="mt-4">
              <button 
              type="submit" 
              class="btn btn-agv-dos btn-block"
              data-bs-dismiss="modal"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->
  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_leader" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a 
                  href="javascript:void(0);" 
                  class="btn btn-agv-dos continue-btn" 
                  data-bs-dismiss="modal" 
                  @click="deleteLeader(record)"
                >
                Eliminar
                </a>
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->

  <!--------------------------------------- Galeria ----------------------------------->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_gallery">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addGallery">
            <!-- <div class="form-group">
              <label>Titulo</label>
              <input 
              class="form-control" 
              name="txt-rotulo" 
              v-model="title_img_gallery"
              />
            </div> -->
            <div class="form-group">
              <label>Descripción Español</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion"
              v-model="desc_img_gallery_es">
              </textarea>
            </div>
            <div class="form-group">
              <label>Descripcion ingles</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion"
              v-model="desc_img_gallery_en">
              </textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeGallery"
              />
              <div class="img-preview">
                <img :src="img_preview_gallery"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->
  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_gallery">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editGallery">
            <!-- <div class="form-group">
              <label>Titulo</label>
              <input 
              class="form-control" 
              name="txt-rotulo" 
              v-model="title_img_gallery"
              />
            </div> -->
            <div class="form-group">
              <label>Descripción Español</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion"
              v-model="desc_img_gallery_es">
              </textarea>
            </div>
            <div class="form-group">
              <label>Descripcion ingles</label>
              <textarea 
              class="form-control" 
              name="txt-descripcion"
              v-model="desc_img_gallery_en">
              </textarea>
            </div>
            <div class="form-group">
              <label>Imagen</label>
              <input 
              type="file" 
              class="form-control" 
              name="txt-imagen" 
              accept="image/png, image/gif, image/jpeg"
              @change="handlePhotoChangeGallery"
              />
              <div class="img-preview">
                <img :src="img_preview_gallery"/>
              </div>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->
  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_gallery" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" 
                class="btn btn-agv-dos continue-btn" 
                data-bs-dismiss="modal" 
                @click="deleteGallery(record)"
                >
                Eliminar
                </a>
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->

  <!------------------------------ Testimonios ----------------------------->
  
  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add_testimony">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addTestimonial">
            <!-- <div class="form-group">
              <label>Nombre</label>
              <input 
                class="form-control" 
                name="txt-rotulo" 
                v-model="name_testimonial" 
              />
            </div>
            <div class="form-group">
              <label>Cargo</label>
              <textarea 
                class="form-control" 
                name="txt-descripcion"
                v-model="work_pos_testimonial">
              </textarea>
            </div> -->
            <div class="form-group">
              <label>Texto</label>
              <textarea 
                class="form-control" 
                name="txt-descripcion"
                v-model="text_testimonial">
              </textarea>
            </div>
            <div class="form-group">
              <label>Url Video</label>
              <input 
              type="text" 
              class="form-control" 
              v-model="video_testimonial"
              />
            </div>
            <div style="padding:56.25% 0 0 0;position:relative;width:100%;">
              <iframe 
                :src="video_testimonial" 
                frameborder="0" 
                allow="autoplay; picture-in-picture; clipboard-write;" 
                style="position:absolute;top:0;left:0;width:100%;height:100%;
              ">
              </iframe>
            </div>
            <!-- <div class="form-group">
              <label>Imagen</label>
              <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeTestimonial"
              />
              <div class="img-preview">
                <img :src="img_preview_testimonial"/>
              </div>
            </div> -->
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Modal -->
  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit_card">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Registro</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editTestimonial">
            <!-- <div class="form-group">
              <label>Nombre</label>
              <input 
                class="form-control" 
                name="txt-rotulo" 
                v-model="name_testimonial"
              />
            </div>
            <div class="form-group">
              <label>Cargo</label>
              <textarea 
                class="form-control" 
                name="txt-descripcion" 
                v-model="work_pos_testimonial">
              </textarea>
            </div> -->
            <div class="form-group">
              <label>Texto</label>
              <textarea 
                class="form-control" 
                name="txt-descripcion"
                v-model="text_testimonial">
              </textarea>
            </div>
            <div class="form-group">
              <label>Url Video</label>
              <input 
              type="text" 
              class="form-control" 
              v-model="video_testimonial"
              />
            </div>
            <div style="padding:56.25% 0 0 0;position:relative;width:100%;">
              <iframe 
                :src="video_testimonial" 
                frameborder="0" 
                allow="autoplay; picture-in-picture; clipboard-write;" 
                style="position:absolute;top:0;left:0;width:100%;height:100%;
              ">
              </iframe>
            </div>
            <!-- <div class="form-group">
              <label>Imagen</label>
              <input 
                type="file" 
                class="form-control" 
                name="txt-imagen" 
                accept="image/png, image/gif, image/jpeg"
                @change="handlePhotoChangeTestimonial"
              />
              <div class="img-preview">
                <img :src="img_preview_testimonial"/>
              </div>
            </div> -->
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->

  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete_card" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-agv-dos continue-btn" data-bs-dismiss="modal" @click="deleteTestimonial(record)"
                  >Eliminar</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->


</template>

<style>
    .ver-video{
        max-width: 100%;
        position: relative;
    }

    .ver-video video{
      width: 100%;
    }

    .ver-imagen{
        max-width: 330px;
        position: relative;
    }

    .ver-imagen button, .ver-video button {
        position: absolute;
        right: 16px;
        top: 16px;
    }
</style>

<script>

import {router} from "@/router";

const fnbaseToCols = (column) => {
  return {
        title: column.title,
        dataIndex: column.dataIndex,
        key: column.dataIndex,
        sorter : false,
        class: column?.class ?? "" ,
    }
};

const baseColsTableAttributes = [
  // { title: "N°", dataIndex: "index"},
  { title: "Descripcion", dataIndex: "description"},
  // { title: "Foto", dataIndex: "photo"},
  { title: "Foto", dataIndex: "s3_url"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableAttributes = baseColsTableAttributes.map ( fnbaseToCols );

const baseColsTableLeaders = [
  // { title: "N°", dataIndex: "index"},
  { title: "Nombre", dataIndex: "name"},
  { title: "Cargo", dataIndex: "work_position"},
  // { title: "Foto", dataIndex: "photo"},
  { title: "Foto", dataIndex: "s3_url"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableLeaders = baseColsTableLeaders.map ( fnbaseToCols );

const baseColsTableGallery = [
  // { title: "N°", dataIndex: "index"},
  // { title: "Title", dataIndex: "title"},
  { title: "Descripcion Español", dataIndex: "es_description"},
  { title: "Descripcion Ingles", dataIndex: "en_description"},
  // { title: "Foto", dataIndex: "photo"},
  { title: "Foto", dataIndex: "s3_url"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableGallery = baseColsTableGallery.map ( fnbaseToCols );

const baseColsTableTestimonials = [
  // { title: "N°", dataIndex: "index"},
  // { title: "Nombre", dataIndex: "name"},
  // { title: "Cargo", dataIndex: "position"},
  { title: "Texto", dataIndex: "text"},
  { title: "Url Video", dataIndex: "video"},
  // { title: "Imagen", dataIndex: "s3_url"},
  // { title: "Imagen", dataIndex: "photo"},
  { title: "Acciones", dataIndex: "id", class: "text-end"},
];
const columnsTableTestimonials = baseColsTableTestimonials.map ( fnbaseToCols );

import axiosIns from '@/plugins/axios.js';
import { ref } from "vue";
const currentDate = ref(new Date());

export default {
  data() {
    return {
      columnsTableAttributes,
      columnsTableLeaders,
      columnsTableGallery,
      columnsTableTestimonials,
      title: "Nuestra Cultura",
      text: "Mantenimientos Páginas",
      text1: "Nuestra Cultura",
      filterInputsDisplay: "none",
      startdate: currentDate,
      
      dataTableAttributes:[],
      dataTableFiltAttributes:[],
      dataTableLeaders:[],
      dataTableFiltLeaders:[],
      dataTableGallery:[],
      dataTableFiltGallery:[],
      dataTableTestimonials:[],
      dataTableFiltTestimonials:[],

      id_attribute:null,
      desc_attribute:null,
      img_attribute:null,
      img_preview_attribute:null,
      searched_attribute:null,

      id_leader:null,
      name_leader:null,
      work_pos_leader:null,
      img_leader:null,
      img_preview_leader:null,
      searched_leader:null,

      id_img_gallery:null,
      title_img_gallery:null,
      desc_img_gallery_es:null,
      desc_img_gallery_en:null,
      img_gallery:null,
      img_preview_gallery:null,
      searched_img_gallery:null,

      id_testimonial:null,
      name_testimonial:null,
      work_pos_testimonial:null,
      text_testimonial:null,
      img_testimonial:null,
      video_testimonial:null,
      img_preview_testimonial:null,
      searched_testimonial:null,
      searched_gallery:null,

      language:null,
      dialogLoading: false
    };
  },
  beforeRouteEnter(to, from, next){
    if (!localStorage.getItem('userDataAdmin')) {
      router.push('/admin/login');
    }else{
      next()
    }
  },
  mounted(){
    this.getAttributes()
    this.getLeaders()
    this.getGallery()
    this.getTestimonials()
  },
  methods: {

    // -------------------- Atributos -------------------- //

    handlePhotoChangeAttribute(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_attribute = file;
        this.img_preview_attribute = URL.createObjectURL(file);
      }
    },

    addAttribute(){
      const yo = this       
      const formData = new FormData();
      formData.append('desc_attribute', yo.desc_attribute);
      formData.append('img_attribute', yo.img_attribute);
      formData.append('language', yo.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createAttribute/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.getAttributes()
            yo.clearValuesAttribute()
            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getAttributes(){
      const yo = this
      yo.dataTableAttributes=[]
      yo.dataTableFiltAttributes=[]
      const config = {
        method: 'get',
        url: '/talentoagv/readAttributes/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
              if(r['key_idioma_id'] == yo.language){
                yo.dataTableAttributes.push(r)
                yo.dataTableFiltAttributes.push(r)
              }
            }
            // yo.dataTableAttributes = response.data['result']
            // yo.dataTableFiltAttributes = response.data['result']
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalAttribute(datos){
      const yo = this
      yo.id_attribute = datos['id']
      yo.desc_attribute = datos['description']
      yo.img_preview_attribute = datos['s3_url']
    },

    editAttribute(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_attribute', yo.id_attribute);
      formData.append('desc_attribute', yo.desc_attribute);
      if (yo.img_attribute) {
        formData.append('img_attribute', this.img_attribute);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateAttribute/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.clearValuesAttribute()
            yo.getAttributes()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalAttribute(datos){
      const yo = this
      yo.id_card = datos['id']
    },

    deleteAttribute(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_attribute,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteAttribute/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getAttributes()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesAttribute(){
      const yo = this
      yo.id_attribute = null
      yo.desc_attribute = null
      yo.img_attribute = null
      yo.img_preview_attribute = null
    },

    // ---------------------- Lideres ---------------------- //

    handlePhotoChangeLeader(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_leader = file;
        this.img_preview_leader = URL.createObjectURL(file);
      }
    },

    addLeader(){
      const yo = this       
      const formData = new FormData();
      formData.append('name_leader', yo.name_leader);
      formData.append('work_pos_leader', yo.work_pos_leader);
      formData.append('img_leader', yo.img_leader);
      formData.append('language', yo.language);

      const config = {
        method: 'post',
        url: '/talentoagv/createLeader/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.getLeaders()
            yo.clearValuesLeader()
            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getLeaders(){
      const yo = this
      yo.dataTableLeaders = []
      yo.dataTableFiltLeaders = []
      const config = {
        method: 'get',
        url: '/talentoagv/readLeaders/',
      }

      if(this.$store.getters.currentAdminLanguage == 'es'){
        yo.language = '1'
      }
      else if(this.$store.getters.currentAdminLanguage == 'en'){
        yo.language = '2'
      }

      axiosIns(config)
        .then(function (response) {
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
              if(r['key_idioma_id'] == yo.language){
                yo.dataTableLeaders.push(r)
                yo.dataTableFiltLeaders.push(r)
              }
            }
            // yo.dataTableLeaders = response.data['result']
            // yo.dataTableFiltLeaders = response.data['result']
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalLeader(datos){
      const yo = this
      yo.id_leader = datos['id']
      yo.name_leader = datos['name']
      yo.work_pos_leader = datos['work_position']
      yo.img_preview_leader = datos['photo']
    },

    editLeader(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_leader', yo.id_leader);
      formData.append('name_leader', yo.name_leader);
      formData.append('work_pos_leader', yo.work_pos_leader);
      formData.append('img_leader', yo.img_leader);

      if (yo.img_leader) {
        formData.append('img_leader', this.img_leader);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateLeader/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.getLeaders()
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.clearValuesLeader()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalLeader(datos){
      const yo = this
      yo.id_leader = datos['id']
    },

    deleteLeader(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_leader,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteLeader/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getLeaders()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesLeader(){
      const yo = this
      yo.id_leader=null
      yo.name_leader=null
      yo.work_pos_leader=null
      yo.img_leader=null
      yo.img_preview_leader=null
    },

    // -------------------------- Galeria ------------------------- //
    
    handlePhotoChangeGallery(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_gallery = file;
        this.img_preview_gallery = URL.createObjectURL(file);
      }
    },

    addGallery(){
      const yo = this       
      const formData = new FormData();
      formData.append('desc_img_gallery_es', yo.desc_img_gallery_es);
      formData.append('desc_img_gallery_en', yo.desc_img_gallery_en);
      formData.append('img_gallery', yo.img_gallery);

      const config = {
        method: 'post',
        url: '/talentoagv/createGallery/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.getGallery()
            // yo.clearValuesGallery()
            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getGallery(){
      const yo = this
      const config = {
        method: 'get',
        url: '/talentoagv/readGallery/',
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            yo.dataTableGallery = response.data['result']
            yo.dataTableFiltGallery = response.data['result']
            // yo.getMainPageData();
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalGallery(datos){
      const yo = this
      yo.id_img_gallery = datos['id']
      // yo.title_img_gallery = datos['title']
      yo.desc_img_gallery_es = datos['es_description']
      yo.desc_img_gallery_en = datos['en_description']
      yo.img_preview_gallery = datos['photo']
    },

    editGallery(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_img_gallery', yo.id_img_gallery);
      formData.append('desc_img_gallery_es', yo.desc_img_gallery_es);
      formData.append('desc_img_gallery_en', yo.desc_img_gallery_en);
      if (yo.img_gallery) {
        formData.append('img_gallery', this.img_gallery);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateGallery/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.clearValuesGallery()
            yo.getGallery()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalGallery(datos){
      const yo = this
      yo.id_img_gallery = datos['id']
    },

    deleteGallery(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_img_gallery,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteGallery/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getGallery()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesGallery(){
      const yo = this
      yo.id_img_gallery = null
      yo.title_img_gallery = null
      yo.desc_img_gallery = null
      yo.img_gallery = null
      yo.img_preview_gallery = null
    },

    // --------------------- Testimonials --------------------- //

    handlePhotoChangeTestimonial(event) {
      const file = event.target.files[0];
      if (file) {
        this.img_testimonial = file;
        this.img_preview_testimonial = URL.createObjectURL(file);
      }
    },

    addTestimonial(){
      const yo = this       
      const formData = new FormData();
      formData.append('name_testimonial', yo.name_testimonial);
      formData.append('work_pos_testimonial', yo.work_pos_testimonial);
      formData.append('text_testimonial', yo.text_testimonial);
      formData.append('img_testimonial', yo.img_testimonial);
      formData.append('video_testimonial', yo.video_testimonial);
      formData.append('language', yo.language);
      formData.append('pagina', '2');
      formData.append('seccion', '14');

      const config = {
        method: 'post',
        url: '/talentoagv/createTestimonial/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.getTestimonials()
            yo.clearValuesTestimonial()
            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getTestimonials(){
      const yo = this
      yo.dataTableTestimonials = []
      yo.dataTableFiltTestimonials = []
      const data = JSON.stringify({
        pagina : '2',
        seccion : '14',
      })
      const config = {
        method: 'post',
        url: '/talentoagv/readTestimonials/',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for(let r of resultado){
              if(r['key_idioma_id'] == yo.language){
                yo.dataTableTestimonials.push(r)
                yo.dataTableFiltTestimonials.push(r)
              }
            }
            // yo.dataTableTestimonials = response.data['result']
            // yo.dataTableFiltTestimonials = response.data['result']
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModalTestimonial(datos){
      const yo = this
      yo.id_testimonial = datos['id']
      yo.name_testimonial = datos['name']
      yo.work_pos_testimonial = datos['position']
      yo.text_testimonial = datos['text']
      yo.img_preview_testimonial = datos['photo']
      yo.video_testimonial = datos['video']
    },

    editTestimonial(){
      const yo = this       
      const formData = new FormData();
      formData.append('id_testimonial', yo.id_testimonial);
      formData.append('name_testimonial', yo.name_testimonial);
      formData.append('work_pos_testimonial', yo.work_pos_testimonial);
      formData.append('text_testimonial', yo.text_testimonial);
      formData.append('video_testimonial', yo.video_testimonial);

      if (yo.img_testimonial) {
        formData.append('img_testimonial', this.img_testimonial);
      }

      const config = {
        method: 'post',
        url: '/talentoagv/updateTestimonial/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.clearValuesTestimonial()
            yo.getTestimonials()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModalTestimonial(datos){
      const yo = this
      yo.id_testimonial = datos['id']
    },

    deleteTestimonial(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id_testimonial,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteTestimonial/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getTestimonials()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesTestimonial(){
      const yo = this
      yo.id_testimonial=null
      yo.name_testimonial=null
      yo.work_pos_testimonial=null
      yo.text_testimonial=null
      yo.img_testimonial=null
      yo.video_testimonial=null
      yo.img_preview_testimonial=null
    },

    //-------------- Busqueda Local en Tabla --------------//

    localSearch(valor, datos, tabla){
      console.log("SSSS")
      const yo = this
      let searched_value = valor.toLowerCase() // Convertir a minúsculas para búsqueda case insensitive
      let resultados = []
      
      // Recorrer cada objeto en la lista de datos
      for (let obj of datos) {
        // Recorrer cada propiedad (campo) del objeto
        for (let key in obj) {
          // Verificar si el valor de la propiedad contiene la palabra clave buscada
          if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searched_value)) {
            resultados.push(obj); // Retornar el objeto completo si se encuentra la palabra clave
            break;
          }
        }
      }

      if(resultados){
        if(tabla == 'attributes'){
          yo.dataTableFiltAttributes = resultados
        }else if(tabla == 'leaders'){
          yo.dataTableFiltLeaders = resultados
        }else if(tabla == 'gallery'){
          yo.dataTableFiltGallery = resultados
        }else if(tabla == 'testimonial'){
          yo.dataTableFiltTestimonials = resultados
        }
      }else{
        yo.dataTableFiltAttributes = yo.dataTableAttributes
        yo.dataTableFiltLeaders = yo.dataTableLeaders
        yo.dataTableFiltGallery = yo.dataTableGallery
        yo.dataTableFiltTestimonials = yo.dataTableTestimonials
      }
    },

  },
};
</script>
